import React, { Component } from 'react';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';

import Select from 'views/select/Select';
import Button from 'views/button/Button';

import './selectList.scss';

import FaClose from 'react-icons/lib/fa/close';
import _ from 'lodash';

export default class SelectList extends Component {



    handleSelect = (value) => {
      if(this.props.onSelect) {
        this.props.onSelect(value)
      }
    }

    handleAddButtonClick = () => {
        if(this.state.addValue) {
            this.handleSelect(this.state.addValue);
            this.setState({
                addValue: null
            })
        }
    }

    handleDelClick = (val) => {
        if(this.props.onDelete) {
            this.props.onDelete(val);
        }
    }

    getAddOptions = () => {
        return _.filter(this.props.options, (o) => !_.find(this.props.selected, (s)=> s.value==o.value))
    }

    render() {
        const {className, children, onInputChange, ...otherProps} = this.props;
        const selected = _.filter(this.props.options, (o) => {
            return _.find(this.props.selected, (s) => s == o.value)
        });

        return (
            <div className={`aselectlist ${className}`}>
                <div className="aselectlist-top">
                    <Select className="form-select" {...{onInputChange}} options={this.getAddOptions()} value={this.state.addValue} onChange={(opt) => this.setState({addValue: opt ? opt.value : null})} >
                        {children}
                    </Select>
                    <Button className="aselectlist-add" onClick={this.handleAddButtonClick}>
                        <FormattedMessage
                            id="selectlist.add"
                            defaultMessage="Add"
                        />
                    </Button>
                </div>
                <div className="aselectlist-selected">
                    <For each="item" of={selected}>
                        <div className="aselectlist-selected-row">
                            <If condition={this.props.rowRenderer}>
                                {this.props.rowRenderer(item.value)}
                            <Else />
                                <div className="aselectlist-selected-label">{item.label}</div>
                            </If>

                            <FaClose className="aselectlist-selected-del" onClick={() => this.handleDelClick(item.value)} />
                        </div>
                    </For>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/views/selectList/SelectList.js